import Configs from "../../vendorConfigs/Configs";
import BetModel from "../../../core/src/model/BetModel";
import BuyFeatureModel from "../../../core/src/model/BuyFeatureModel";
import DebugModel from "../../../core/src/model/DebugModel";
import GameModel from "../../../core/src/model/GameModel";
import SpinModel from "../../../core/src/model/SpinModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import VendorModel from "../../model/VendorModel";

export default class SpinRequest implements IRequestBuilder {

    get method() {
        return "POST";
    }
    
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/play";
    }
    
    get requestData() {

        let debugData = DebugModel.debugData;

        let forcedOutcome;
        if(DebugModel.debugData) {
            forcedOutcome = DebugModel.debugData; 
        }
        DebugModel.cleanUp();
        let response;
        GameModel.incrementRestoreVersion();
        let lastRestoreVersion = GameModel.restoreVersion;
        let index =
          SpinModel.currentGeneration && SpinModel.generations
            ? SpinModel.generations[SpinModel.currentGeneration].index
            : 0;
        let state = JSON.stringify({
          generation: index,
          roundFinished: SpinModel.roundFinish,
          restoreVersion: GameModel.restoreVersion,
        });
    
        if (!SpinModel.inFreegames()) {
            if (BuyFeatureModel.hasBuyFeatureIsTriggered ||
                BuyFeatureModel.isInBuyFeatureFreeSpins) {
                let baseResult = {
                    sid: GameModel.sessionID,
                    g: Configs.vendorServer.gameId,
                    ga: "spin", // gameAction
                    ba: BuyFeatureModel.getTotalBet(), // betAmount
                    forcedOutcome,
                    response,
                    restoreState: state,
                    restoreVersion: lastRestoreVersion,
                    buyFeature: true
                };
                let extraParams: any[] = BuyFeatureModel.extraParams;
                if (extraParams.length) {
                    extraParams.forEach((param) => {
                        baseResult = Object.assign(baseResult, param);
                    })
                }

                return baseResult;
            } 
            else if(debugData) {
                let baseResult = {
                    sid: GameModel.sessionID,
                    g: Configs.vendorServer.gameId,
                    ba: BetModel.totalBet,
                    forcedOutcome,
                    response,
                    restoreState: state,
                    restoreVersion: lastRestoreVersion,
                }
                let extraParams = {
                    ga: "spin",
                }
                if(SpinModel.hasFreespinsWon()) {
                    extraParams["option"] = SpinModel.featureMode;
                    extraParams["ga"] = "select";
                }
                return baseResult = Object.assign(baseResult, extraParams); 
            } else {
                return {
                    sid: GameModel.sessionID,
                    g: Configs.vendorServer.gameId,
                    ga: "spin", // gameAction
                    ba: BetModel.totalBet, // betAmount
                    forcedOutcome,
                    response,
                    restoreState: state,
                    restoreVersion: lastRestoreVersion,
                };
            }
    
        } else {
            return {
                sid: GameModel.sessionID,
                g: Configs.vendorServer.gameId,
                ga: "spin", // gameAction
                ba: VendorModel.freeGames.ba,
                restoreState: state,
                restoreVersion: lastRestoreVersion,
                expectFreeRounds: true
                // restoreState : restoreState, //unknown usage. "SpinStart" is used in other client basegamecontroller
                // restoreVersion : restoreVersion //unknown usage
            };
        }
    }
}
